/**
 * `GET /me/calendar-connections/google` as `queryOptions` — ONE cache entry for `/konto`'s Kalendarz
 * tab, its return page and `/rezerwacje`'s one-time prompt. The key stands outside `/konto`'s
 * `['account']` prefix, so a profile save does not re-read the connection.
 *
 * One retry, as everywhere: an older backend's 404 just hides what reads it.
 */

import { queryOptions } from '@tanstack/react-query';

import { getMeCalendarConnectionsGoogle } from '~/shared/api/generated/endpoints/my-google-calendar-connection/my-google-calendar-connection';

export const googleCalendarQueryKey = ['google-calendar-connection'] as const;

export function googleCalendarQueryOptions() {
  return queryOptions({
    queryKey: googleCalendarQueryKey,
    queryFn: ({ signal }) => getMeCalendarConnectionsGoogle(undefined, signal),
  });
}
